

import * as api from "../constant/NewAPI";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import Select from "react-select";
import * as XLSX from "xlsx";
import { all_routes } from "../router/all_routes";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";

// import * as api from "../constant/API";

const assessmentReport = () => {

    const routes = all_routes;

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    const [searchInput, setSearchInput] = useState('');
    const [instituteList, setInstituteList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [assessmentList, setAssessmentList] = useState([]);
    const [reportList, setReportList] = useState([]);
    const [detailsList, setDetailsList] = useState([]);
    const [groupId, setGroupId] = useState('');
    const [institutionId, setInstitutionId] = useState('');
    const [batchId, setBatchId] = useState('All');
    const [assessmentId, setAssessmentId] = useState('All');
    const [searchQuery, setSearchQuery] = useState('');
    const [showTable, setShowTable] = useState(false);

    useEffect(() => {
        instituteTypeList()
    }, [])

    function instituteTypeList() {
        const instTypeList = api.InstituteTypeList + '/' + roleId //"?userId=" + userId + "&roleId=" + roleId;
        fetch(instTypeList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((typResponse) => typResponse.json())
            .then((typResult) => {
                if (typResult.error == true) {
                    if (typResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (typResult.data != null) {
                        setGroupList(typResult.data)
                    }
                }

            })
            .catch((error) => {
                console.log('Failed to fetch Institute Type List', error);
            })
    }

    function getInstitutes(grpId) {
        const institute = api.GetReportInstitutions + '/' + roleId + '/' + grpId// "?institutionTypeId=" + grpId + "&userId=" + userId + "&roleId=" + roleId;
        fetch(institute, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((instReponse) => instReponse.json())
            .then((instResult) => {
                if (instResult.error == true) {
                    if (instResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (instResult.data != null) {
                        setInstituteList(instResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch institution list", error)
            })
    }

    function getBatchList(insid) {
        const getbtchlst = api.GetBatchAssessment + '/' + insid //"?InstId=" + insid;
        fetch(getbtchlst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((btchResponse) => btchResponse.json())
            .then((btchResult) => {
                if (btchResult.error == true) {
                    if (btchResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (btchResult.data != null) {
                        setBatchList(btchResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch batch list.", error)
            })
    }

    function getAssessmentList() {
        const assessmentlist = api.GetAssessment + '/' + institutionId// "?InstId=" + institutionId;
        fetch(assessmentlist, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((assessmentResponse) => assessmentResponse.json())
            .then((assessmentResult) => {
                if (assessmentResult.error == true) {
                    if (assessmentResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (assessmentResult.data != null) {
                        setAssessmentList(assessmentResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch assessment list", error);
            })
    }

    function assessReport() {
        let bchId = batchId;
        let asmntId = assessmentId;
        if (bchId == '') {
            bchId = 'All';
        } if (asmntId == '') {
            asmntId = 'All'
        }
        const asmntRprt = api.GetAssessmentReport + '/' + groupId + '/' + bchId + '/' + institutionId + '/' + asmntId //+ "?insType=" + groupId + "&batchName=" + batchId + "&Institute=" + institutionId + "&assessmentName=" + assessmentId;
        fetch(asmntRprt, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((asmntResponse) => asmntResponse.json())
            .then((asmntResult) => {
                if (asmntResult.error == true) {
                    if (asmntResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (asmntResult.data != null) {
                        setReportList(asmntResult.data)
                    }
                    // setReportList(asmntResult.data)
                    setShowTable(true)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch report list", error);
            })
    }

    function showDetails(itm) {
        const scdlId = itm.assessmentScheduleId;
        const assessmentDetails = api.ReportAssessmentData + '/' + batchId + '/' + assessmentId + '/' + scdlId + '/' + institutionId //+ "?batchName=" + batchId + "&Institute=" + institutionId + "&assessmentName=" + assessmentId + "&assessmentId=" + asmntId + "&schedule=" + scdlId;
        fetch(assessmentDetails, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((dtlsResponse) => dtlsResponse.json())
            .then((dtlsResult) => {
                if (dtlsResult.error == false) {
                    setDetailsList(dtlsResult.data)
                } else {
                    if (dtlsResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(dtlsResult.message)
                }
                // setDetailsList(dtlsResult.data)
            })
    }

    function exportnow() {
        const formData = new FormData();
        formData.append('institutionType', groupId);
        formData.append('batchId', batchId);
        formData.append('institutionId', institutionId);
        formData.append('assessmentId', assessmentId);
        const exprt = api.AssessmentReportExport;
        fetch(exprt, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData,
        })
            .then((exportReponse) => exportReponse.json())
            .then((exportResult) => {
                if (exportResult.error == true) {
                    if (exportResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    const blob = new Blob([exportResult.data], { type: "application/vnd.ms-excel" });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "AssessmentReport.xls"; // Save file as .xls
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
            })
            .catch((error) => {
                console.log("Failed to export Assessment Report", error);
            })
    }

    const detailsRender = (rowData) => {
        return (
            <Link to="#" data-bs-toggle="modal" data-bs-target="#assessment-list" onClick={() => { showDetails(rowData); }}>
                <i className="feather feather-eye"></i>View
            </Link>
        );
    };

    const filteredData = reportList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const filteredAssessment = detailsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchQuery.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchRender = (rowData, column) => {
        return <span>{rowData.batchName}</span>
    };

    const dateRender = (rowData, column) => {
        return <span>{formatDate(rowData.assessmentDate)}</span>
    };

    const assessmentTypeRender = (rowData, column) => {
        return <span>{rowData.assessmentType}</span>
    };

    const sportRender = (rowData, column) => {
        return <span>{rowData.sportsName}</span>
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">
                                    <i className="fa fa-university"></i>
                                    Assessment Report
                                </h3>
                            </div>
                            <div>
                                <Link
                                    to={routes.reports}
                                    className="btn btn-primary save-profile"
                                >
                                    <i className="fas fa-arrow-left"></i>Back
                                </Link>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="court-tab-content">
                                        <div className="court-tab-content">
                                            <div className="card card-tableset">
                                                <div className="card-body">
                                                    <div className="coache-head-blk">
                                                        <div className="row align-items-center">
                                                            <div className="row col-md-12">
                                                                <div className="row col-md-12 court-sortby sortbyset">
                                                                    <div className="col-md-4">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Institute Group</h6></label>
                                                                            <Select
                                                                                value={groupList.find(grp => grp.institutionGroupId === groupId) ? {
                                                                                    value: groupId,
                                                                                    label: groupList.find(grp => grp.institutionGroupId === groupId).institutionGroupName
                                                                                } : null}
                                                                                onChange={(e) => {
                                                                                    setGroupId(e.value);
                                                                                    getInstitutes(e.value)
                                                                                }}
                                                                                options={groupList.map(grp => ({
                                                                                    value: grp.institutionGroupId,
                                                                                    label: grp.institutionGroupName
                                                                                }))}>
                                                                            </Select>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Institute</h6></label>
                                                                            <Select value={instituteList.find(inst => inst.institutionId === institutionId) ? {
                                                                                value: institutionId,
                                                                                label: instituteList.find(inst => inst.institutionId === institutionId).institutionName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setInstitutionId(e.value)
                                                                                    getBatchList(e.value)
                                                                                }}
                                                                                options={instituteList.map(inst => ({
                                                                                    value: inst.institutionId,
                                                                                    label: inst.institutionName
                                                                                }))}
                                                                                placeholder={"Select Institute"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Batch</h6></label>
                                                                            <Select value={batchList.find(btch => btch.batchId === batchId) ? {
                                                                                value: batchId,
                                                                                label: batchList.find(btch => btch.batchId === batchId).batchName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setBatchId(e.value)
                                                                                    getAssessmentList();
                                                                                }}
                                                                                options={batchList.map(btch => ({
                                                                                    value: btch.batchId,
                                                                                    label: btch.batchName
                                                                                }))}
                                                                                placeholder={"Select Batch"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Assessment</h6></label>
                                                                            <Select value={assessmentList.find(asmnt => asmnt.assessmentTypeId === assessmentId) ? {
                                                                                value: assessmentId,
                                                                                label: assessmentList.find(asmnt => asmnt.assessmentTypeId === assessmentId).assessmentType
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setAssessmentId(e.value)
                                                                                }}
                                                                                options={assessmentList.map(asmnt => ({
                                                                                    value: asmnt.assessmentTypeId,
                                                                                    label: asmnt.assessmentType
                                                                                }))}
                                                                                placeholder={"Select Assessment"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="save-changes text-sm mt-4">
                                                                            <Link
                                                                                to="#"
                                                                                className="btn btn-primary save-profile"
                                                                                onClick={assessReport}
                                                                            >
                                                                                Submit
                                                                            </Link>
                                                                            <Link
                                                                                to="#"
                                                                                className={`btn btn-primary save-profile`}
                                                                                onClick={exportnow}
                                                                            >
                                                                                Export to Excel
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12 border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                                    {showTable && (
                                                                        <>
                                                                            <div className="col-md-12">
                                                                            </div>
                                                                            <div className="col-md-12">
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="dataTables_filter">
                                                                                    <label>
                                                                                        <input
                                                                                            type="text"
                                                                                            value={searchInput}
                                                                                            onChange={(e) => setSearchInput(e.target.value)}
                                                                                            placeholder="Search"
                                                                                            className="form-control"
                                                                                        />
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}

                                                                </div>
                                                            </div>
                                                            {showTable && (
                                                                <>
                                                                    <div className="tab-content mt-2">
                                                                        <div
                                                                            className="tab-pane fade show active"
                                                                            id="nav-Recent"
                                                                            role="tabpanel"
                                                                            aria-labelledby="nav-Recent-tab"
                                                                            tabIndex={0}
                                                                        >
                                                                            <div className="table-responsive table-datatble">
                                                                                <DataTable
                                                                                    className="table datatable"
                                                                                    value={filteredData}
                                                                                    paginator
                                                                                    rows={10}
                                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                                    pageLinkSize={3}
                                                                                >
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="slNo"
                                                                                        body={slNoRender}
                                                                                        header="Sl No"
                                                                                    // headerStyle={{ backgroundColor: "#0f2a4e", color: "#FFFF" }}
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="batchName"
                                                                                        body={batchRender}
                                                                                        header="Batch"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="scheduleDate"
                                                                                        body={dateRender}
                                                                                        header="Assessment Date"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="assessmentType"
                                                                                        body={assessmentTypeRender}
                                                                                        header="Assessment Type"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="sportsName"
                                                                                        body={sportRender}
                                                                                        header="Sport"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        body={detailsRender}
                                                                                    ></Column>
                                                                                </DataTable>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Assessment List */}
            <div
                className="modal custom-modal fade request-modal"
                id="assessment-list"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    Assessment Details
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <div className="row text-sm-end">
                                <div className="dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            placeholder="Search Students"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="table-responsive table-datatble sortable">
                                    <table className="table datatable">
                                        <thead className="thead-light">
                                            <tr>
                                                <th className="text-uppercase">Sl No.</th>
                                                <th className="text-uppercase">Student Name</th>
                                                <th className="text-uppercase">Skill</th>
                                                <th className="text-uppercase">Grade</th>
                                            </tr>
                                            {Array.isArray(filteredAssessment) && filteredAssessment.map((asmnt, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{asmnt.StudentName}</td>
                                                    <td>{asmnt.skillName}</td>
                                                    <td>{asmnt.gradeType}</td>
                                                </tr>
                                            ))}
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Assessment List */}

        </>
    );
};

export default assessmentReport;